// src/api.js
/**
 * Centralized API fetch wrapper with auth header support.
 */

function getBaseUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  const isProduction = window.location.protocol === 'https:';
  return isProduction
    ? `${window.location.protocol}//${window.location.host}`
    : `http://${window.location.hostname}:8000`;
}

/**
 * Fetch wrapper that auto-adds Authorization header.
 *
 * @param {string} path - API path (e.g. '/auth/me')
 * @param {object} options
 * @param {string} [options.token] - JWT token (if not provided, fetches without auth)
 * @param {string} [options.method] - HTTP method (default GET)
 * @param {object} [options.body] - Request body (will be JSON-stringified)
 */
export async function apiFetch(path, options = {}) {
  const { token, method = 'GET', body, ...rest } = options;
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${getBaseUrl()}${path}`, {
    method: body ? 'POST' : method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
    ...rest,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${res.status}: ${text}`);
  }

  return res.json();
}
